import type { ElementType } from 'react'

import type { InlineNotificationVariant, VariantStyleMap } from './types'

export const getNotificationIcon = (
  styleMap: VariantStyleMap,
  variant: InlineNotificationVariant
): ElementType => styleMap[variant].icon
